module.exports = __webpack_public_path__ + "img/selected_marker.20a66093.png";